export default function getUserName(data) {
    const { firstName, firstname, lastName, lastname, preferredName } = data;
    return `${preferredName || firstName || firstname} ${lastName || lastname}`;
}